import React from 'react';
import Catalog from './catalog/catalog.js';

const Pages = ( props ) => {
   return <Catalog />
}

export default Pages